import { computed } from "vue";
export function useSaveSearchModal() {
  var saveSearchModalIcons = computed(function () {
    return window["saveSearchData"]["icons"];
  });
  var saveSearchModalLabels = computed(function () {
    return window["saveSearchData"]["labels"];
  });
  var realEstateMiniItem = computed(function () {
    return window["_serializedRealEstateBean"];
  });
  var realEstateBean = computed(function () {
    return window["_serializedSearchBean"];
  });
  var ssmPlace = computed(function () {
    return window["_serializedPlace"];
  });
  return {
    saveSearchModalIcons: saveSearchModalIcons,
    saveSearchModalLabels: saveSearchModalLabels,
    realEstateMiniItem: realEstateMiniItem,
    realEstateBean: realEstateBean,
    ssmPlace: ssmPlace
  };
}